<div class="cc-content-wrapper lobby-wrapper">
  <div class="central-view-selection row">
    
    <div class="radio col-md-3 mt-1">
      <!-- <button kendoButton class="sub-tab-btn">{{views[0].value}}</button> -->
      <label>
        <input id="radio-1" type="radio" [(ngModel)]="radioSelected" kendoRadioButton name="view_name" value="{{views[0].value | translate}}"
          (change)="onItemChange(views[0])">
        {{views[0].value | translate}}
      </label>
    </div>

    <div class="radio col-md-3 mt-1">
      <!-- <button (click)="onItemChange(views[1])" kendoButton class="sub-tab-btn">{{views[1].value}}</button> -->
      <label>
        <input id="radio-2" type="radio" [(ngModel)]="radioSelected" kendoRadioButton name="view_name" value="{{views[1].value | translate}}"
          (change)="onItemChange(views[1])">
        {{views[1].value | translate}}
      </label>
    </div>

    <div class="radio col-md-3 mt-1">
      <!-- <button kendoButton class="sub-tab-btn">{{views[2].value}}</button> -->
      <label>
        <input id="radio-3" type="radio" [(ngModel)]="radioSelected" kendoRadioButton name="view_name" value="{{views[2].value | translate}}"
          (change)="onItemChange(views[2])">
        {{views[2].value | translate}}
      </label>
    </div>

    <div *ngIf="radioSelectedString" class="w-100">
      <div *ngIf="radioSelectedString.id==1">
        <app-lobby-central-lobby-view></app-lobby-central-lobby-view>
      </div>
      <div *ngIf="radioSelectedString.id==2">
        <app-lobby-central-staff-status-view></app-lobby-central-staff-status-view>
      </div>
      <div *ngIf="radioSelectedString.id==3">
        <app-lobby-central-location-view></app-lobby-central-location-view>
      </div>
    </div>

  </div>
</div>


